import {engineContext} from './context.js';

(function(global){
'use strict';
const VERSION='0.1.0-alpha';

function validStatus(x){
  return ['CONSTRUCTIVE','REVIEW','RISK_ELEVATED','ROTATION_RISK','INSUFFICIENT_DATA'].includes(x);
}
function normalize(input){
  input=input||{};
  const market=input.market||{};
  const company=input.company||{};
  return Object.freeze({
    market:Object.freeze({
      status:validStatus(market.status)?market.status:'INSUFFICIENT_DATA',
      breadth:market.breadth||null,
      dispersion:market.dispersion||null,
      rotation:market.rotation||null,
      verificationCoverage:typeof market.verificationCoverage==='number'?market.verificationCoverage:null
    }),
    company:Object.freeze({
      symbol:company.symbol||null,
      sector:company.sector||null,
      region:company.region||null,
      owned:company.owned===true,
      watchlist:company.watchlist===true
    })
  });
}
function pressure(input){
  const x=normalize(input), m=x.market;
  let level='LOW', reasons=[];
  if(m.status==='RISK_ELEVATED'){level='HIGH';reasons.push('Broad regional weakness');}
  else if(m.status==='ROTATION_RISK'){level='MODERATE';reasons.push('High regional dispersion / rotation');}
  else if(m.status==='REVIEW'){level='MODERATE';reasons.push('Mixed global market context');}
  else if(m.status==='INSUFFICIENT_DATA'){level='UNKNOWN';reasons.push('Insufficient verified global context');}
  if(m.verificationCoverage!==null && m.verificationCoverage<0.6){
    if(level!=='HIGH') level='UNKNOWN';
    reasons.push('Low verification coverage');
  }
  return Object.freeze({level,reasons:Object.freeze(reasons)});
}
function decisionContext(input){
  const x=normalize(input), p=pressure(x);
  const review = p.level==='HIGH' || p.level==='MODERATE' || p.level==='UNKNOWN';
  return Object.freeze({
    marketPressure:p.level,
    review,
    timingContext: p.level==='HIGH'?'RISK_ELEVATED'
      :p.level==='MODERATE'?'REVIEW'
      :p.level==='UNKNOWN'?'INVESTIGATE':'OPEN',
    companyQualityOverride:false,
    entryGateOverride:false,
    tradeSignal:false,
    reasons:p.reasons,
    scope:x.company.owned?'OWNED':x.company.watchlist?'WATCHLIST':'RESEARCH'
  });
}
function contradiction(input){
  input=input||{};
  const d=decisionContext(input);
  const companyStrength=String(input.companyStrength||'UNKNOWN').toUpperCase();
  if(companyStrength==='STRONG' && d.marketPressure==='HIGH'){
    return Object.freeze({
      state:'CONTEXT_CONTRADICTION',
      message:'Strong company evidence, but broad market pressure is elevated.',
      action:'REVIEW_TIMING',
      tradeSignal:false
    });
  }
  if(companyStrength==='WEAK' && d.marketPressure==='LOW'){
    return Object.freeze({
      state:'COMPANY_SPECIFIC_RISK',
      message:'Benign market context does not excuse weak company evidence.',
      action:'REVIEW_COMPANY',
      tradeSignal:false
    });
  }
  return Object.freeze({state:'NO_MAJOR_CONTRADICTION',message:null,action:'NO_ACTION',tradeSignal:false});
}
function selfTest(){
 const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
 let x=decisionContext({market:{status:'RISK_ELEVATED',verificationCoverage:1},company:{owned:true}});
 ok('broad weakness creates high pressure',x.marketPressure==='HIGH');
 ok('high pressure raises timing review',x.timingContext==='RISK_ELEVATED');
 ok('market never overrides Company Quality',x.companyQualityOverride===false);
 ok('market never overrides Entry Gate',x.entryGateOverride===false);
 ok('bridge never emits trade signal',x.tradeSignal===false);
 ok('owned scope preserved',x.scope==='OWNED');
 x=decisionContext({market:{status:'CONSTRUCTIVE',verificationCoverage:1},company:{watchlist:true}});
 ok('constructive context remains low pressure',x.marketPressure==='LOW');
 ok('watchlist scope preserved',x.scope==='WATCHLIST');
 x=decisionContext({market:{status:'CONSTRUCTIVE',verificationCoverage:.4}});
 ok('low verification blocks confidence',x.marketPressure==='UNKNOWN');
 let c=contradiction({market:{status:'RISK_ELEVATED',verificationCoverage:1},companyStrength:'STRONG'});
 ok('strong company vs weak market is explicit contradiction',c.state==='CONTEXT_CONTRADICTION');
 c=contradiction({market:{status:'CONSTRUCTIVE',verificationCoverage:1},companyStrength:'WEAK'});
 ok('good market cannot excuse weak company',c.state==='COMPANY_SPECIFIC_RISK');
 ok('contradiction remains review-only',c.tradeSignal===false);
 return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}
const API={VERSION,normalize,pressure,decisionContext,contradiction,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestMarketDecisionBridge=Object.freeze(API);
})(engineContext);
